import { DepInjMixin as DI, Constructor, HasDependencies } from '@ahoy/aquarium/dist/core/Dependency';
import { LitElement } from 'lit';
import { DeviceAwareComponent } from '../views/components/device-aware-component';

export { define, requires, resolve, Constructor, HasDependencies } from '@ahoy/aquarium/dist/core/Dependency';

// Overloading to support local types.
// Todo: Figure out how to make typescript infer the type without this
function DepInjMixin<K extends {}>(Base: ObjectConstructor): Constructor<HasDependencies<K, ObjectConstructor>>;
// eslint-disable-next-line no-redeclare
function DepInjMixin<K extends {}>(Base: Constructor<DeviceAwareComponent>): Constructor<HasDependencies<K, DeviceAwareComponent>>;
// eslint-disable-next-line no-redeclare
function DepInjMixin<K extends {}>(Base: Constructor<LitElement>): Constructor<HasDependencies<K, LitElement>>;
// eslint-disable-next-line no-redeclare
function DepInjMixin<K extends {}>(Base: Constructor<any>): Constructor<HasDependencies<K, any>> {
  return DI<K>(Base);
}

export { DepInjMixin };